import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React from 'react';
import IntegeratedDevice from './IntegeratedDevice';
import RecentlyOpened from './RecentlyOpened';
import SynchrotronTrips from './SynchrotronTrips';
import HitsImage from './HitsImage';
import useRMLite from 'CustomHooks/useRMLite';
import { EProductEditions } from 'enums/EProductEditions';
import useProductEdition from 'CustomHooks/useProductEdition.';

export default function DashboardBody() {
  const rmLite = useRMLite();
  const productEdition = useProductEdition();

  return (
    <div id='dashboardbody-grid-container' className="gridContainer flex">
      <div id='dashboardbody-left-grid' className="w-1/4">
        <RecentlyOpened />
      </div>
      <div id='dashboardbody-center-grid' 
        className={`${rmLite ? 'w-3/4' : 'w-1/2'} h-full flex flex-col gap-2`}>
        {!rmLite ? (
          <div id='dashboardbody-rmf' className="w-full h-[35%]">
            <RMSvgIcon
              id='dashboardbody-rmf-svg-icon'
              name="RMFlowBanner"
              preserveAspectRatio="none"
              noFill={true}
              height={'100%'}
              width={'100%'}
            />
          </div>
        ) : null}
        <div id='dashboardbody-hits-image' className={`${rmLite ? 'h-full' : 'h-[64%]'}`}>
          <HitsImage />
        </div>
      </div>
      {!rmLite ? (
        <div id='dashboardbody-right-grid' className="w-1/4 flex flex-col gap-2">
          {productEdition === EProductEditions.Enterprise && (
            <div id='dashboardbody-sychrotron-trips' className="h-3/4">
              <SynchrotronTrips />
            </div>
          )}
          <div id='dashboardbody-integerated-device' className="h-1/4">
            <IntegeratedDevice />
          </div>
        </div>
      ) : null}
    </div>
  );
}
